import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ============================================================
// Legacy cache cleanup
// Keep active service workers intact so FCM push can subscribe.
// ============================================================
function cleanupLegacyCaches() {
  if (!('caches' in window)) return;

  window.addEventListener('load', async () => {
    try {
      const keys = await caches.keys();
      const staleKeys = keys.filter((k) => /^ea-shell-v[0-9]+$/i.test(k) && k !== 'ea-shell-v2');
      await Promise.all(staleKeys.map((k) => caches.delete(k)));
    } catch (err) {
      console.warn('Legacy cache cleanup failed:', err.message);
    }
  });
}

cleanupLegacyCaches();

// ============================================================
// React Root
// ============================================================
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
